export const STATES = [
  // State restricted to New York - AT1-2135
  // { value: 'Alabama', display: 'Alabama' },
  // { value: 'Alaska', display: 'Alaska' },
  // { value: 'Arizona', display: 'Arizona' },
  // { value: 'Arkansas', display: 'Arkansas' },
  // { value: 'California', display: 'California' },
  // { value: 'Colorado', display: 'Colorado' },
  // { value: 'Connecticut', display: 'Connecticut' },
  // { value: 'Delaware', display: 'Delaware' },
  // { value: 'District of Columbia', display: 'District of Columbia' },
  // { value: 'Florida', display: 'Florida' },
  // { value: 'Georgia', display: 'Georgia' },
  // { value: 'Hawaii', display: 'Hawaii' },
  // { value: 'Idaho', display: 'Idaho' },
  // { value: 'Illinois', display: 'Illinois' },
  // { value: 'Indiana', display: 'Indiana' },
  // { value: 'Iowa', display: 'Iowa' },
  // { value: 'Kansas', display: 'Kansas' },
  // { value: 'Kentucky', display: 'Kentucky' },
  // { value: 'Louisiana', display: 'Louisiana' },
  // { value: 'Maine', display: 'Maine' },
  // { value: 'Maryland', display: 'Maryland' },
  // { value: 'Massachusetts', display: 'Massachusetts' },
  // { value: 'Michigan', display: 'Michigan' },
  // { value: 'Minnesota', display: 'Minnesota' },
  // { value: 'Mississippi', display: 'Mississippi' },
  // { value: 'Missouri', display: 'Missouri' },
  // { value: 'Montana', display: 'Montana' },
  // { value: 'Nebraska', display: 'Nebraska' },
  // { value: 'Nevada', display: 'Nevada' },
  // { value: 'New Hampshire', display: 'New Hampshire' },
  // { value: 'New Jersey', display: 'New Jersey' },
  // { value: 'New Mexico', display: 'New Mexico' },
  { display: "New York", value: "New York" },
  // { value: 'North Carolina', display: 'North Carolina' },
  // { value: 'North Dakota', display: 'North Dakota' },
  // { value: 'Ohio', display: 'Ohio' },
  // { value: 'Oklahoma', display: 'Oklahoma' },
  // { value: 'Oregon', display: 'Oregon' },
  // { value: 'Pennsylvania', display: 'Pennsylvania' },
  // { value: 'Rhode Island', display: 'Rhode Island' },
  // { value: 'South Carolina', display: 'South Carolina' },
  // { value: 'South Dakota', display: 'South Dakota' },
  // { value: 'Tennessee', display: 'Tennessee' },
  // { value: 'Texas', display: 'Texas' },
  // { value: 'Utah', display: 'Utah' },
  // { value: 'Vermont', display: 'Vermont' },
  // { value: 'Virginia', display: 'Virginia' },
  // { value: 'Washington', display: 'Washington' },
  // { value: 'West Virginia', display: 'West Virginia' },
  // { value: 'Wisconsin', display: 'Wisconsin' },
  // { value: 'Wyoming', display: 'Wyoming' },
];

export const ALL_STATES = [
  // State restricted to New York - AT1-2135
  { display: "Alabama", value: "Alabama" },
  { display: "Alaska", value: "Alaska" },
  { display: "Arizona", value: "Arizona" },
  { display: "Arkansas", value: "Arkansas" },
  { display: "California", value: "California" },
  { display: "Colorado", value: "Colorado" },
  { display: "Connecticut", value: "Connecticut" },
  { display: "Delaware", value: "Delaware" },
  { display: "District of Columbia", value: "District of Columbia" },
  { display: "Florida", value: "Florida" },
  { display: "Georgia", value: "Georgia" },
  { display: "Hawaii", value: "Hawaii" },
  { display: "Idaho", value: "Idaho" },
  { display: "Illinois", value: "Illinois" },
  { display: "Indiana", value: "Indiana" },
  { display: "Iowa", value: "Iowa" },
  { display: "Kansas", value: "Kansas" },
  { display: "Kentucky", value: "Kentucky" },
  { display: "Louisiana", value: "Louisiana" },
  { display: "Maine", value: "Maine" },
  { display: "Maryland", value: "Maryland" },
  { display: "Massachusetts", value: "Massachusetts" },
  { display: "Michigan", value: "Michigan" },
  { display: "Minnesota", value: "Minnesota" },
  { display: "Mississippi", value: "Mississippi" },
  { display: "Missouri", value: "Missouri" },
  { display: "Montana", value: "Montana" },
  { display: "Nebraska", value: "Nebraska" },
  { display: "Nevada", value: "Nevada" },
  { display: "New Hampshire", value: "New Hampshire" },
  { display: "New Jersey", value: "New Jersey" },
  { display: "New Mexico", value: "New Mexico" },
  { display: "New York", value: "New York" },
  { display: "North Carolina", value: "North Carolina" },
  { display: "North Dakota", value: "North Dakota" },
  { display: "Ohio", value: "Ohio" },
  { display: "Oklahoma", value: "Oklahoma" },
  { display: "Oregon", value: "Oregon" },
  { display: "Pennsylvania", value: "Pennsylvania" },
  { display: "Rhode Island", value: "Rhode Island" },
  { display: "South Carolina", value: "South Carolina" },
  { display: "South Dakota", value: "South Dakota" },
  { display: "Tennessee", value: "Tennessee" },
  { display: "Texas", value: "Texas" },
  { display: "Utah", value: "Utah" },
  { display: "Vermont", value: "Vermont" },
  { display: "Virginia", value: "Virginia" },
  { display: "Washington", value: "Washington" },
  { display: "West Virginia", value: "West Virginia" },
  { display: "Wisconsin", value: "Wisconsin" },
  { display: "Wyoming", value: "Wyoming" },
];
